module.exports = __webpack_public_path__ + "static/img/3.bc06eea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/3.jpg
// module id = kTn2
// module chunks = 0